import { render } from "./submain-list.vue?vue&type=template&id=73eac7de&scoped=true"
import script from "./submain-list.vue?vue&type=script&lang=js"
export * from "./submain-list.vue?vue&type=script&lang=js"

import "./submain-list.vue?vue&type=style&index=0&id=73eac7de&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73eac7de"]])

export default __exports__